import { TDeviceType } from '@cian/ui-kit';

export enum EPageType {
  Career = 'career',
  CareerVacancies = 'careerVacancies',
  CareerVacancy = 'careerVacancy',
  CareerTeamMarketing = 'careerTeamMarketing',
  CareerTeamAnalytics = 'careerTeamAnalytics',
  CareerTeamTechnologies = 'careerTeamTechnologies',
  CareerTeamProduct = 'careerTeamProduct',
  CareerTeamBackoffice = 'careerTeamBackoffice',
  CareerPersonDanil = 'careerPersonDanil',
  CareerPersonNikita = 'careerPersonNikita',
  CareerPersonNatalia = 'careerPersonNatalia',
  CareerPersonDima = 'careerPersonDima',
  CareerPersonVeronica = 'careerPersonVeronica',
  Listing = 'listing',
  Card = 'card',
}

export interface IPageState {
  type: EPageType;
  deviceType: TDeviceType;
}
